<!-- FULL SIDEBAR VIEW -->
<span *ngIf="navService.sidebarState.sidenavOpen">
  <div [ngClass]="{ open: navService.sidebarState.sidenavOpen }" class="sidebar-left rtl-ps-none" (mouseleave)="onMainSidebarLeave()">
    <ng-scrollbar class="vh-100" visibility="hover" appearance="compact">
      <div class="logo">
        <img src="./assets/images/logo.png" alt="" />
      </div>
      <ul class="navigation-left">
        <li [ngClass]="{ active: item.active }" (click)="onClickChangeActiveFlag(item)" class="nav-item lvl1" *ngFor="let item of nav">
          <div class="nav-item-hold" routerLink="{{ item.state }}" (click)="closeChildNav()" (mouseenter)="onHoverLink(item)" *ngIf="!item.disabled && item.type === 'link'">
            <i [class]="'nav-icon fontAwesome_Li_Class ' + item.icon"></i>
            <span class="nav-text ts" *ngIf="navService.sidebarState.sideIcon">{{ item.name }}</span>
          </div>
          <div class="nav-item-hold" [routerLink]="item.sub?.[0]?.state" (mouseenter)="selectItem(item)" *ngIf="!item.disabled && item.type === 'dropDown'">
            <i [class]="'nav-icon fontAwesome_Li_Class ' + item.icon"></i>
            <span class="nav-text ts2" *ngIf="navService.sidebarState.sideIcon">{{ item.name }}</span>
          </div>
          <div class="nav-item-hold" (mouseenter)="onHoverLink(item)" *ngIf="!item.disabled && item.type === 'extLink'">
            <a [href]="item.state" target="_blank">
              <i [class]="'nav-icon fontAwesome_Li_Class ' + item.icon"></i>
              <span class="nav-text ts1" *ngIf="navService.sidebarState.sideIcon">{{ item.name }}</span>
            </a>
          </div>
          <div class="triangle" *ngIf="!item.disabled"></div>
        </li>
      </ul>
    </ng-scrollbar>
  </div>
 
  <!-- FULL CHILD NAVIGATION -->
  <div *ngIf="navService.sidebarState.childnavOpen" [ngClass]="{ open: navService.sidebarState.childnavOpen }" class="sidebar-left-secondary rtl-ps-none" (mouseenter)="onChildNavEnter()" (mouseleave)="onChildNavLeave()">
    <header>
      <h6>Apps</h6>
      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
    </header>
    <ng-container *ngTemplateOutlet="menuTemplate; context: { parentItem: navService.selectedItem }"></ng-container>
  </div>
</span>
 
<!-- ICONS-ONLY SIDEBAR VIEW -->
<span *ngIf="!navService.sidebarState.sidenavOpen">
  <div [ngClass]="{ open: !navService.sidebarState.sidenavOpen }" class="sidebar-left rtl-ps-none" (mouseleave)="onMainSidebarLeave()">
    <ng-scrollbar class="vh-100" visibility="hover" appearance="compact">
      <div class="logo">
        <img src="./assets/images/logo.png" alt="" />
      </div>
      <ul class="navigation-left" style="width: 80px;">
        <li [ngClass]="{ active: item.active }" (click)="onClickChangeActiveFlag(item)" class="nav-item lvl1" *ngFor="let item of nav">
          <div [title]="item.name" class="nav-item-hold" style="padding-top: 15%;" routerLink="{{ item.state }}" (click)="closeChildNav()" (mouseenter)="onHoverLink(item)" *ngIf="!item.disabled && item.type === 'link'">
            <i [class]="'nav-icon ' + item.icon + ' ' + 'fontAwesome_Li_Class'"></i>
            <span *ngIf="navService.sidebarState.sideIcon" class="nav-text" style="position: absolute; left: 85px; white-space: nowrap;">
              {{ item.name }}
            </span>
          </div>
          <div class="nav-item-hold" style="padding-top: 15%;" [routerLink]="item.sub?.[0]?.state" (mouseenter)="selectItem(item)" *ngIf="!item.disabled && item.type === 'dropDown'">
            <i [class]="'nav-icon ' + item.icon + ' ' + 'fontAwesome_Li_Class'"></i>
            <span *ngIf="navService.sidebarState.sideIcon" class="nav-text" style="position: absolute; left: 85px; white-space: nowrap;">
              {{ item.name }}
            </span>
          </div>
          <div class="nav-item-hold" style="padding-top: 15%;" (mouseenter)="onHoverLink(item)" *ngIf="!item.disabled && item.type === 'extLink'">
            <a [href]="item.state" target="_blank">
              <i [class]="'nav-icon ' + item.icon + ' ' + 'fontAwesome_Li_Class'"></i>
              <span *ngIf="navService.sidebarState.sideIcon" class="nav-text" style="position: absolute; left: 85px; white-space: nowrap;">
                {{ item.name }}
              </span>
            </a>
          </div>
          <div class="triangle" *ngIf="!item.disabled"></div>
        </li>
      </ul>
    </ng-scrollbar>
  </div>
 
  <!-- ICONS-ONLY CHILD NAVIGATION -->
  <div *ngIf="navService.sidebarState.childnavOpen" [ngClass]="{ open: navService.sidebarState.childnavOpen }" style="left: 5% !important;" class="sidebar-left-secondary icons-only rtl-ps-none" (mouseenter)="onChildNavEnter()" (mouseleave)="onChildNavLeave()">
    <header>
      <h6>Apps</h6>
      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
    </header>
    <ng-container *ngTemplateOutlet="menuTemplate; context: { parentItem: navService.selectedItem }"></ng-container>
  </div>
</span>
 
<!-- TEMPLATE FOR CHILD NAVIGATION -->
<ng-template #menuTemplate let-parentItem="parentItem">
  <ul class="childNav" appDropdown>
    <li *ngFor="let item of parentItem?.sub" appDropdownLink class="nav-item">
      <a routerLink="{{ item.state }}" *ngIf="item.type === 'link'" class="" routerLinkActive="open">
        <i *ngIf="item.icon" [class]="'nav-icon ' + item.icon + ' ' + 'fontAwesome_Li_Class'"></i>
        <span class="item-name lvl1">{{ item.name }}</span>
      </a>
      <div *ngIf="item.type === 'dropDown'">
        <a appDropdownToggle [ngClass]="{ open: item.active }" routerLinkActive="open">
          <i *ngIf="item.icon" [class]="'nav-icon ' + item.icon + ' ' + 'fontAwesome_Li_Class'"></i>
          <span class="item-name">{{ item.name }}</span>
          <i class="dd-arrow i-Arrow-Down"></i>
        </a>
        <ng-container *ngTemplateOutlet="menuTemplate; context: { parentItem: item }"></ng-container>
      </div>
    </li>
  </ul>
</ng-template>
 
<!-- OVERLAY FOR CLOSING CHILD NAV -->
<div [ngClass]="{ open: navService.sidebarState.childnavOpen }" class="sidebar-overlay" (click)="closeChildNav()"></div>